import tmhRequest from '@/config/tmhRequest'

export default {
    searchOilReportCount: function (data) {
        return tmhRequest({
            url: '/report/tmh/oilreport/searchoilreportcount',
            method: 'post',
            data: data,
        })
    },
    searchOilReportByPage: function (data) {
        return tmhRequest({
            url: '/report/tmh/oilreport/searchoilreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportOilReport: function (data) {
        return tmhRequest({
            url: '/report/tmh/oilreport/exportoilreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/report/oilreport.js